<template>
    <v-row>
        <div class="col-md-12 home-box">
            <Breadcrumbs :title="'All Other Income Entries'"></Breadcrumbs>
            <AllIncomeEntries></AllIncomeEntries>

        </div>
    </v-row>
    
</template>



<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import AllIncomeEntries from "@/components/Income/AllOtherIncomeTable.vue";
export default {
    name: 'grn',
    components:{
        Breadcrumbs,
        AllIncomeEntries

    }
}
</script>